import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumb = ({ customPath = null }) => {
  const location = useLocation();

  const routeLabels = {
    '/analytics-overview': 'Overview',
    '/call-history-analytics': 'Call History',
    '/agent-performance': 'Agent Performance',
    '/escalations-monitoring': 'Escalations',
    '/knowledge-base-analytics': 'Knowledge Base'
  };

  const generateBreadcrumbs = () => {
    if (customPath && Array.isArray(customPath)) {
      return customPath;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/analytics-overview' }];

    if (pathSegments?.length > 0) {
      const currentPath = `/${pathSegments?.join('/')}`;
      const label = routeLabels?.[currentPath] || pathSegments?.[pathSegments?.length - 1]?.split('-')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
      
      breadcrumbs?.push({ label, path: currentPath });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="navigation-breadcrumb" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2 flex-wrap">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          const isFirst = index === 0;

          return (
            <li key={crumb?.path} className="breadcrumb-item">
              {!isLast ? (
                <>
                  <Link 
                    to={crumb?.path} 
                    className="breadcrumb-link"
                    aria-label={`Navigate to ${crumb?.label}`}
                  >
                    {isFirst && <Icon name="Home" size={14} className="mr-1" />}
                    {crumb?.label}
                  </Link>
                  <Icon 
                    name="ChevronRight" 
                    size={14} 
                    className="breadcrumb-separator mx-1" 
                  />
                </>
              ) : (
                <span className="breadcrumb-current" aria-current="page">
                  {crumb?.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default NavigationBreadcrumb;